import * as CardApplication from '@/src/experiences/card-application'
import { withFinishedApplicationGate } from '@/src/experiences/card-application/withFinishedApplicationGate'
import { Redirect } from 'expo-router'

export default withFinishedApplicationGate(
  CardApplication.Components.withCardPlatform(
    CardApplication.Screens.ApprovedScreen,
    CardApplication.Screens.Highnote.ApplicationApproved,
  ),
  (finishedStatus) =>
    finishedStatus === 'DENIED' ? (
      <Redirect href="/main/card-application/applicationDenied" />
    ) : undefined,
)
